<template>
  <div class="purchase-container">
    <!-- 账户信息卡片 -->
    <a-card class="content-card flow-card">
      <div class="flow-header">
        <a-icon type="info-circle" class="flow-icon" />
        <div class="flow-title">{{ translate('purchase.accountInfo') }}</div>
      </div>
      <div class="flow-stats">
        <div class="flow-item">
          <span class="flow-label">{{ translate('purchase.currentPlan') }}</span>
          <span class="flow-value">{{ translate('purchase.noPlan') }}</span>
        </div>
        <a-divider style="margin: 12px 0; border-color: rgba(255, 255, 255, 0.2);" />
        <div class="flow-item">
          <span class="flow-label">{{ translate('purchase.perGigabytePrice') }}</span>
          <span class="flow-value">${{ Mkprice }}/GB</span>
        </div>
      </div>
    </a-card>

    <!-- 购买选择卡片 -->
    <a-card class="content-card proxy-result-card highlight-card">
      <div class="card-header">
        <a-icon type="shopping-cart" class="header-icon" />
        <div class="header-title">{{ translate('purchase.whatTypeBroadband') }}</div>
      </div>

      <a-tabs v-model="value" @change="changeTab()" class="custom-tabs">
        <a-tab-pane key="dtzz" :tab="translate('purchase.dynamicResidence')" class="tab-pane">
          <div class="tab-content">
            <div class="section-title">{{ translate('purchase.needOverGB') }}</div>
            <div class="section-desc">{{ translate('purchase.buyPackage') }}</div>
            
            <div class="select-row">
              <div class="select-item">
                <div class="config-item">
                  <span class="config-label">{{ translate('purchase.selectPackage') }}</span>
                  <a-select v-model="selectlevelValue" @change="changepid" class="custom-select">
                    <a-select-option v-for="item in broadList" :value="item.pid" :key="item.pid">
                      ${{ item.money }} - {{ translate('purchase.dynamicResidence') }} - {{ item.flow }}GB ({{ item.discountNum ? translate('purchase.discountPrice') : ''}}{{ item.discountNum ? ': ' : ''}}${{ item.unitPrice }}{{ item.discountNum ? '*' : ''}}{{ item.discountNum || ''}}/1GB)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div class="action-bar">
              <a-space class="action-buttons">
                <a-button v-for="item in BtnnameList" :key="item.dictValue" @click="PaymentWays(item)" class="action-btn generate-btn">
                  {{ item.dictLabel }}
                </a-button>
              </a-space>
              <div style="flex: 1;"></div>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="jtzz" :tab="translate('purchase.staticResidence')" class="tab-pane">
          <div class="tab-content">
            <div class="section-title">{{ translate('purchase.needOverGB') }}</div>
            <div class="section-desc">{{ translate('purchase.buyPackage') }}</div>
            
            <div class="select-row">
              <div class="select-item">
                <div class="config-item">
                  <span class="config-label">{{ translate('purchase.selectPackage') }}</span>
                  <a-select v-model="selectleveljValue" @change="changepid" class="custom-select">
                    <a-select-option v-for="item in broadListj" :value="item.pid" :key="item.pid">
                      ${{ item.money }} - {{ Kdname }} - {{ item.flow }}GB ({{ item.discountNum ? translate('purchase.discountPrice') : ''}}{{ item.discountNum ? ': ' : ''}}${{ item.unitPrice }}{{ item.discountNum ? '*' : ''}}{{ item.discountNum || ''}}/1GB)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div class="action-bar">
              <a-space class="action-buttons">
                <a-button v-for="item in BtnnameList" :key="item.dictValue" @click="PaymentWays(item)" class="action-btn generate-btn">
                  {{ item.dictLabel }}
                </a-button>
              </a-space>
              <div style="flex: 1;"></div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <!-- 支付弹框 -->
    <a-modal :visible="visiblepay" :width="800" @ok="addflew" @cancel="visiblepay = false"
      :okText="translate('purchase.confirm')" :cancelText="translate('purchase.cancel')"
      class="payment-modal"
    >
      <iframe style="width: 100%;height: 500px;margin-top: 10px;margin-top: -10px;border: none;" :src="payurl"></iframe>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PurchasePage',
  components: {
  },
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    Kdname() {
      return this.translate('purchase.staticResidence');
    },
    discount() {
      return this.translate('purchase.discountPrice');
    },
    secondsCom() {
      return this.seconds < 10 ? '0' + this.seconds : this.seconds;
    }
  },
  data() {
      return {
          uid:localStorage.getItem("userId"),
          pid:0,
          dictValueType:'',
          value: 'dtzz',
          Mkprice: 0,
          payurl:'',
          selectlevel: '',
          selectlevelj: '',
          selectlevelValue: null,
          selectleveljValue: null,
          qrCodeUrl: '1111', // 二维码的内容
          imageUrl:'',

          broadList:[],
          broadLists:[],
          broadListj:[],
          broadListy:[],
          formData:{
              host:'',
              port:'',
              username:'',
              password:'',
          },
          dataLoading: false,
          rowKey: 'index',
          tableLayout: 'auto',
          verticalAlign: 'top',
          bordered: true,
          hover: true,
          pagination: {
              defaultPageSize: 10,
              total: 0,
              defaultCurrent: 1,
          },
          data:[
              { "uid":0,"creatTime":11,"flow":'小姜',"flowOverdue1":5,"flowOverdue4":1,"flowOverdue3":1 }
          ],
          IsoCodeList:[],
          BtnnameList:[],
          flow:'', //总流量
          flowoverdue:'', //剩余流量，获取参数总流量减去该参数
          visiblepay: false, //支付弹框
          minutes: 9,
          seconds: 59,
          timer:'',//定时器名称
      };
  },
  mounted(){
      this.getIsoCodeList();
      this.getBtnnameList();
      this.timecalc();
      this.start();
  },
  methods:{
      //登录状态测试
      getLoginStatus(){
      this.$request.get('/ums/isLoginStates').then((res) => {
      if (res.data.code === 5000) {
              this.$router.push('/login')
              window.localStorage.clear();
              this.$message.warning(this.translate('purchase.loginWarning'));
          }
          })
          .catch((e) => {
          console.log(e);
      })
      }, 
      start(){
          this.timer = setInterval(this.getLoginStatus, 10000); // 第一个参数为方法名的时候不要加括号;
      },
      
      //获取宽带类型
      getIsoCodeList() {
      this.$request.get('/package/getlist').then((res) => {
        if (res.data.code === 200) {
              this.broadList = res.data.data.dtzz || [];
              this.broadListj = res.data.data.jtzz || [];
              //判断下拉框是否有值，有的话默认第一个值的pid，没有则不打开弹框
              if(this.value == 'dtzz' && Array.isArray(this.broadList) && this.broadList.length >0){
                  this.pid = this.broadList[0].pid;
              }else if(this.value == 'jtzz' && Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.pid = this.broadListj[0].pid;
              }else{
                  this.pid = 0;
              }
              //您的每千兆字节价格默认值
              if(Array.isArray(this.broadList) && this.broadList.length >0){
                  this.Mkprice = this.broadList[0].unitPrice
              }else if(Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.Mkprice = this.broadListj[0].unitPrice
              }else{
                  this.Mkprice = 0;
              }
              //设置下拉框默认值
              if(Array.isArray(this.broadList) && this.broadList.length >0){
                  this.selectlevelValue = this.broadList[0].pid;
              }else{
                  this.selectlevelValue = null;
              }
              if(Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.selectleveljValue = this.broadListj[0].pid;
              }else{
                  this.selectleveljValue = null;
              }
              this.changeTab();
          }
          })
          .catch((e) => {
          console.log(e);
          })
          .finally(() => {
          });
      },
      //国际化翻译方法
      translate(key) {
        const lang = this.currentLanguage;
        const translations = {
          'purchase.currentPlan': lang === 'zh' ? '您当前计划' : 'Your current plan',
          'purchase.perGigabytePrice': lang === 'zh' ? '您的每千兆字节价格' : 'Your per gigabyte price',
          'purchase.whatTypeBroadband': lang === 'zh' ? '您需要什么类型的宽带？' : 'What type of broadband do you need?',
          'purchase.needOverGB': lang === 'zh' ? '需要超过几GB的带宽？' : 'Need more than a few GB of bandwidth?',
          'purchase.buyPackage': lang === 'zh' ? '以更优惠的每GB价格购买我们的套餐之一' : 'Buy one of our packages at a more favorable price per GB',
          'purchase.dynamicResidence': lang === 'zh' ? '动态住宅' : 'Dynamic Residence',
          'purchase.staticResidence': lang === 'zh' ? '静态住宅' : 'Static Residence',
          'purchase.discountPrice': lang === 'zh' ? '折扣价' : 'Discount Price',
          'purchase.pleaseSelectPackage': lang === 'zh' ? '请选择套餐' : 'Please select a package',
          'purchase.confirm': lang === 'zh' ? '确认' : 'Confirm',
          'purchase.cancel': lang === 'zh' ? '取消' : 'Cancel',
          'purchase.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
          'purchase.accountInfo': lang === 'zh' ? '账户信息' : 'Account Information',
          'purchase.noPlan': lang === 'zh' ? '无' : 'None',
          'purchase.selectPackage': lang === 'zh' ? '选择套餐' : 'Select Package'
        };
        return translations[key] || key;
      },
      //获取支付按钮名称
      getBtnnameList() {
      this.$request.get('/package/getpassagewaytype?uid=' + this.uid).then((res) => {
        if (res.data.code === 200) {
              console.log(res.data.data);
              this.BtnnameList = res.data.data;
          }
          })
          .catch((e) => {
          console.log(e);
          })
          .finally(() => {
          });
      },

      changeTab(){
        //每次切换tab,重新设置pid
        if(this.value == 'dtzz' ){
            if(Array.isArray(this.broadList) && this.broadList.length >0){
              this.Mkprice = this.broadList[0].unitPrice
              this.pid = this.broadList[0].pid;
              this.selectlevelValue = this.broadList[0].pid;
            }else{
              this.Mkprice = 0
              this.pid = 0;
              this.selectlevelValue = null;
            }
        }
        else if(this.value == 'jtzz' ){
            if(Array.isArray(this.broadListj) && this.broadListj.length >0){
              this.Mkprice = this.broadListj[0].unitPrice
              this.pid = this.broadListj[0].pid;
              this.selectleveljValue = this.broadListj[0].pid;
            }else{
              this.Mkprice = 0
              this.pid = 0;
              this.selectleveljValue = null;
            }
        }
        console.log('切换选项卡后，pid:', this.pid);
      },

      //获取下拉框pid
      changepid(e){
          this.pid = e;
          console.log(this.pid);
      },

      //获取支付订单页面
      getorder(){
          console.log(this.pid);
          this.$request.post('/order/creat',{pid:this.pid,uid:Number(this.uid),passagewayType:this.dictValueType}).then((res) => {
            if (res.data.code === 200) {
              this.payurl = res.data.data.paylink
            }
          })
          .catch((e) => {
            console.log(e);
          })
      },
      //点击按钮弹出支付通道对话框
      PaymentWays(item){
          this.dictValueType = item.dictValue;
          if(this.pid != 0){
              this.getorder();
              this.visiblepay = true;
          }
          else{
              this.$message.warning(this.translate('purchase.pleaseSelectPackage'))
          }
      },
      
      //确认支付
      addflew(){
          console.log(1);
      },
      // 倒计时
      timecalc() {
          var _this = this
          var time = window.setInterval(function () {
              if (_this.seconds === 0 && _this.minutes !== 0) {
              _this.seconds = 59
              _this.minutes -= 1
              } else if (_this.minutes === 0 && _this.seconds === 0) {
              _this.seconds = 0
              _this.timeShow = false
              window.clearInterval(time)           
              sessionStorage.setItem("timeShow",JSON.stringify('false'));
              } else {
              _this.seconds -= 1
              }
          }, 1000)
      },
      
  },
  //清空定时器
  beforeDestroy(){
      if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
      }
  },
  
};
</script>

<style scoped lang="less">
// 品牌色彩变量定义
@primary-color: #1890ff;
@primary-hover: #40a9ff;
@primary-active: #69c0ff;
@success-color: #52c41a;
@warning-color: #faad14;
@error-color: #f5222d;
@text-primary: #262626;
@text-secondary: #595959;
@text-tertiary: #8c8c8c;
@border-color: #f0f0f0;
@border-hover: #e6f7ff;
@bg-primary: #ffffff;
@bg-secondary: #fafafa;
@bg-gradient: linear-gradient(135deg, @bg-secondary 0%, @bg-primary 100%);
@card-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
@card-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.12);

.purchase-container {
  padding: 24px;
  background: #ffffff;
  min-height: calc(100vh - 64px);
}

// 流量统计卡片样式
.flow-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  color: white;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><defs><pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
    opacity: 0.3;
  }
  
  .flow-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-icon {
      font-size: 32px;
      margin-right: 16px;
      color: white;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    
    .flow-title {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  }
  
  .flow-stats {
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      
      .flow-label {
        font-size: 14px;
        opacity: 0.8;
        font-weight: 500;
      }
      
      .flow-value {
        font-size: 28px;
        font-weight: 700;
        letter-spacing: -0.5px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }
  }
  
  :deep(.ant-divider) {
    border-color: rgba(255, 255, 255, 0.2) !important;
    margin: 12px 0 !important;
  }
  
  :deep(.ant-card-body) {
    padding: 32px !important;
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4) !important;
  }
}

// 选择行样式
.select-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .select-item {
    flex: 1;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .config-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .config-label {
    font-size: 14px;
    font-weight: 600;
    color: #595959;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  .header-icon {
    font-size: 24px;
    color: #1890ff;
    margin-right: 16px;
    transition: all 0.3s ease;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
  }
}

// 自定义选择框
.custom-select {
  width: 100%;
  :deep(.ant-select) {
    width: 100%;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    
    .ant-select-selector {
      border-radius: 8px !important;
      height: 40px !important;
      display: flex !important;
      align-items: center !important;
      border: 1px solid #d9d9d9 !important;
      transition: all 0.3s ease !important;
      
      &:hover {
        border-color: #1890ff !important;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15) !important;
      }
      
      &.ant-select-focused {
        border-color: #1890ff !important;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
      }
    }
  }
  
  :deep(.ant-select-selection-placeholder) {
    color: #bfbfbf !important;
    font-size: 14px !important;
  }
}

// 操作按钮样式
.action-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e6f7ff;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
  }
}

.action-buttons {
  gap: 12px;
}

.action-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #d9d9d9;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    border-color: #1890ff;
    color: #1890ff;
  }
}

.generate-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  padding: 0 32px;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%) !important;
  border: none !important;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
    background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%) !important;
  }
  
  &:active {
    transform: translateY(0);
  }
}

// 章节标题
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: @text-primary;
  margin-bottom: 8px;
}

// 章节描述
.section-desc {
  font-size: 14px;
  color: @text-secondary;
  margin-bottom: 24px;
  line-height: 1.6;
}

// 支付模态框
.payment-modal {
  :deep(.ant-modal-header) {
    border-bottom: 1px solid @border-color;
    padding: 20px 24px;
    
    .ant-modal-title {
      font-size: 18px;
      font-weight: 600;
    }
  }
  
  :deep(.ant-modal-body) {
    padding: 24px;
    
    iframe {
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }
  
  :deep(.ant-modal-footer) {
    border-top: 1px solid @border-color;
    padding: 16px 24px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .purchase-container {
    padding: 8px 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav-container {
    padding: 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav-wrap {
    margin: 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav {
    width: 100%;
  }

  .custom-tabs /deep/ .ant-tabs-nav > div {
    display: flex;
    width: 100%;
  }

  .custom-tabs /deep/ .ant-tabs-tab {
    flex: 1 1 0;
    min-width: 0;
    margin: 0 !important;
    padding: 12px 6px !important;
    text-align: center;
    white-space: normal;
  }

  .custom-tabs /deep/ .ant-tabs-tab-arrow-show {
    display: none;
  }
  
  .select-row {
    padding: 16px;
    gap: 16px;
    
    .select-item {
      min-width: 100%;
    }
  }
  
  .action-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
    
    .generate-btn,
    .action-btn {
      width: 100%;
      justify-content: center;
    }
  }
  
  .action-buttons {
    display: flex;
    width: 100%;
    gap: 12px;
    
    .action-btn {
      flex: 1;
    }
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 12px;
    }
  }
  
  .flow-card {
    .flow-stats {
      .flow-item {
        .flow-value {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
